import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useSession } from '@stores/globalData/globalData.store'
import PageRoutes from '@utils/page-routes'

import FeatureExpander from './FeatureExpander'
import FeatureList from './FeatureList'
import { FEATURES } from './FeatureList/constants'
import PlanCard from './PlanCard'

const BasicPlanCard: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()

  return (
    <PlanCard
      planType="basic"
      description={
        <Trans
          i18nKey="plans.basic.description"
          components={[<span className="font-semibold" key="0" />]}
        />
      }
      pricing={
        <p className="mb-4 text-md">
          <Trans i18nKey="plans.basic.pricing">
            <span className="font-medium text-[22px]">${{ price: 0 }}</span>
            <span> / free forever</span>
          </Trans>
        </p>
      }
      className="pb-8 border-gray-border pt-[23px] dark:border-gray-border-dm lg:pb-12">
      <Button
        variant="outline"
        className="mb-1 w-full font-medium disabled:opacity-100"
        onClick={() => {
          window.location.assign(PageRoutes.signUpPath())
        }}
        size="lg"
        disabled={session.isLoggedIn()}>
        {t('plans.basic.action', { context: session.isLoggedIn() ? 'signedIn' : null })}
      </Button>
      <span className="hidden w-full p-2 opacity-0 lg:block">{/* Spacer */}-</span>
      <FeatureExpander>
        <FeatureList features={FEATURES.basic} />
      </FeatureExpander>
    </PlanCard>
  )
}

export default BasicPlanCard
